import { ReactElement } from 'react';

import {
   WaitlistEntryCancelAppointmentCommand,
   WaitlistEntryConfirmAppointmentCommand,
   WaitlistEntryQuery,
} from '@dreryk/egabinet-waitlist-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { PromiseVoidFunction } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type WaitlistEntryConfirmReservationModalActionsRenderProps = {
   confirmAppointment: PromiseVoidFunction;
   cancelAppointment: PromiseVoidFunction;
};

type WaitlistEntryConfirmReservationModalActionsProps = {
   children: (renderProps: WaitlistEntryConfirmReservationModalActionsRenderProps) => ReactElement;
   entryId: number;
   appointmentId: AppointmentId;
   onSuccess: VoidFunction;
};

export const WaitlistEntryConfirmReservationModalActions = (
   props: WaitlistEntryConfirmReservationModalActionsProps
): ReactElement => {
   const { executeAsync: cancelAppointment } = useCqrsCommand<void, void>(
      () => {
         const command = new WaitlistEntryCancelAppointmentCommand();
         command.appointmentId = props.appointmentId;
         command.targetStatus = 'PENDING';
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(translationKeys.successfullyCancelledReservationAndRestoredToWaitlist);
            refetchCqrsQuery(WaitlistEntryQuery);
            props.onSuccess();
         },
      }
   );

   const { executeAsync: confirmAppointment } = useCqrsCommand<void, void>(
      () => {
         const command = new WaitlistEntryConfirmAppointmentCommand();
         command.waitlistEntryId = props.entryId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(translationKeys.successfullyConfirmedAppointment);
            refetchCqrsQuery(WaitlistEntryQuery);
            props.onSuccess();
         },
      }
   );

   return props.children({
      confirmAppointment: confirmAppointment,
      cancelAppointment: cancelAppointment,
   });
};
